import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
export function ToastNotification({ message, type, duration = 3000, onDismiss, }) {
    useEffect(() => {
        const timer = setTimeout(onDismiss, duration);
        return () => clearTimeout(timer);
    }, [duration, onDismiss]);
    return (_jsx("div", { className: `toast toast--${type}`, role: "status", "data-testid": `toast-${type}`, children: message }));
}
